import { request } from "@/request/http";

export default {
    getArtcilePreviewData: (data) => {
        return request("GET", `/index.php/backarticle/getArtcilePreviewData`, data);
    },

};